export default "__VITE_ASSET__DW3gVmuN__"